import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { resolveHideRating } from "../utils";
var assertOptions = function assertOptions(options) {
  return options.staticApiUrl != null && options.tenant != null;
};
export var useHideRating = function useHideRating(_ref) {
  var staticApiUrl = _ref.staticApiUrl,
    tenant = _ref.tenant;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    hideRating = _useState2[0],
    setHideRating = _useState2[1];
  useEffect(function () {
    var options = {
      staticApiUrl: staticApiUrl,
      tenant: tenant
    };
    if (assertOptions(options)) {
      // eslint-disable-next-line no-console -- log error to console
      resolveHideRating(options).then(setHideRating).catch(console.error);
    }
  }, [staticApiUrl, tenant]);
  return hideRating;
};
//# sourceMappingURL=useHideRating.js.map